import { useMemo } from "react";
import { useToken } from "@rentablo/api";
import { useMandatorContext } from "@rentablo/theming";
import {
  DEFAULT_LOGIN_PATH,
  resolveLoginRedirectPath,
} from "./mandatorLoginConfig";

const BASE = import.meta.env.VITE_APP_V2_URL;

const normalize = (p: string) => p.replace(/\/+$/, "") || "/";

export function useLoginRoute() {
  const { mandatorSlug } = useMandatorContext();
  const { data: token } = useToken();

  return useMemo(() => {
    const path = resolveLoginRedirectPath(mandatorSlug, !token);

    const isLoginPath = (pathname: string) => {
      const normalizedPath = normalize(pathname);
      return (
        normalizedPath === DEFAULT_LOGIN_PATH ||
        normalizedPath === normalize(path)
      );
    };

    return {
      loginRedirectUrl: `${BASE}${path}`,
      isLoginPath,
    };
  }, [mandatorSlug, token]);
}
